import { useState } from 'react';
import { ExpandMore } from '@mui/icons-material';
import {
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Box
} from '@mui/material';
import { downloadFile, getDownloadFileName } from '../../../helpers';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { LoadingButton } from '@mui/lab';
import { useSnackbar } from 'notistack';
import { getSpecPriceSheet } from '../../../fetch';

export const SpecHomePriceSheet = () => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleDownload = async () => {
    try {
      setIsLoading(true);
      const res = await getSpecPriceSheet();
      return downloadFile(res.data, getDownloadFileName(res));
    } catch (error) {
      enqueueSnackbar(error?.Detail ?? `Error, unable to download file, please try again.`, {
        variant: 'error'
      });
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Accordion className={classes.root}>
        <AccordionSummary
          className={classes.accordion}
          expandIcon={<ExpandMore />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <div className={classes.topPanelSummaryWrapper}>
            <Typography variant="h6">Spec Home Price Sheet</Typography>
          </div>
        </AccordionSummary>
        <AccordionDetails className={classes.details}>
          <div className={classes.panelSummaryWrapper}>
            <Box mt={1}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <LoadingButton
                    id="generate-price-guide"
                    color="primary"
                    variant="contained"
                    loading={isLoading}
                    onClick={() => handleDownload()}
                  >
                    Generate & Download
                  </LoadingButton>
                </Grid>
              </Grid>
            </Box>
          </div>
        </AccordionDetails>
      </Accordion>
    </>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    maxWidth: '100%',
    border: `1px solid ${theme.palette.grey[300]}`,
    overflowX: 'hidden'
  },
  accordion: {
    padding: '0 16px',
    '&& .MuiAccordionSummary-expandIcon': {
      padding: 3
    }
  },
  topPanelSummaryWrapper: {
    marginTop: theme.spacing(0.5),
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    '&:first-child': { marginTop: 0 }
  },
  panelSummaryWrapper: {
    '&:first-child': { marginTop: 0 }
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    padding: '12px 16px',
    backgroundColor: theme.palette.grey[100]
  }
}));
